import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Cookies from 'universal-cookie';
import moment from 'moment';
import _l from 'lodash';

import * as history from '../../common/history.js';
import Dialogs from "../../common/Dialogs.js";
import * as DataAPI from "../../common/DataAPI";

const cookies = new Cookies();

class Login extends Component {
  constructor() {
    super();
    this.state = {
      id: '',
      password: '',
    };

    this.updateLoginState = this.updateLoginState.bind(this);
    this.login = this.login.bind(this);
  }

  updateLoginState(event) {
    const fieldName = event.target.name;
    const value = event.target.value;
    this.setState({ [fieldName]: value });
  }

  login(event) {
    event.preventDefault();

    DataAPI.post('/api/adminPanel/login', {
      id: _.toLower(this.state.id),
      password: this.state.password,
    }, (err, user) => {
      if (err) return this.dialogs.error(err);

      const expires = moment().endOf('day').toDate();
      const permissions = ['canAddDeposit', 'canLoginAdminPanel'];
      cookies.set('isLoggedIn', true, { expires, path: '/' });
      _.forEach(permissions, permission => {
        cookies.set(permission, user.role[permission], {
          expires,
          path: '/'
        });
      });

      history.replace('/adminPanel');
      window.location.reload();
    });
  }

  render() {
    return (
      <div className="admin-panel-login-block">
        <Grid className="login-block">
          <Row center="xs">
            <Col className="login-form">
              <form onSubmit={this.login}>
                <div className="title">控制台</div>
                <div className="content">
                  <div>
                    <TextField
                      name="id"
                      floatingLabelText="ID"
                      value={this.state.id}
                      onChange={this.updateLoginState}
                    />
                  </div>
                  <div>
                    <TextField
                      name="password"
                      type="password"
                      floatingLabelText="密碼"
                      value={this.state.password}
                      onChange={this.updateLoginState}
                    />
                  </div>
                  <br />
                  <RaisedButton type="submit" label="登入" primary={true} fullWidth={true} />
                </div>
              </form>
            </Col>
          </Row>
        </Grid>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// client/adminPanel/login/Login.js